import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const opportunityMasterService = createApi({
    reducerPath: 'opportunityMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['OpportunityMaster'],
    endpoints: (builder) => ({

        getAllOpportunityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityMasterController.getAllOpportunityMaster}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        getOpportunityMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityMasterController.getOpportunityMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        saveOpportunityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityMasterController.saveOpportunityMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            }
        }),

        updateOpportunityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityMasterController.updateOpportunityMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            }
        }),

        deleteOpportunityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityMasterController.deleteOpportunityMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        getAllOpportunityMasterBySearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityMasterController.getAllOpportunityMasterBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        findAllOpportunityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityMasterController.findAllOpportunityMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        bulkSaveOpportunityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityMasterController.bulkSaveOpportunityMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    }),
});

export const {
    useGetAllOpportunityMasterMutation,
    useGetOpportunityMasterByIdMutation,
    useSaveOpportunityMasterMutation,
    useUpdateOpportunityMasterMutation,
    useDeleteOpportunityMasterMutation,
    useGetAllOpportunityMasterBySearchMutation,
    useFindAllOpportunityMasterMutation,
    useBulkSaveOpportunityMasterMutation
} = opportunityMasterService;
